// extracted by mini-css-extract-plugin
module.exports = {"reports":"Reports_reports__3yAvF"};